/**
 * The label for an Assistant conversation, shared by the history list and the
 * header breadcrumb so both always name a conversation the same way: the
 * stored name, else the first-message preview, else "New chat".
 */
export function assistantThreadTitle(name: string | null | undefined, preview: string | undefined): string {
  const trimmedName = name?.trim()
  if (trimmedName) return trimmedName
  const trimmedPreview = preview?.trim()
  if (trimmedPreview) return trimmedPreview
  return 'New chat'
}
